import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/insights')({
  staticData: {
    title: 'pages.insights.title',
    description: 'pages.insights.description',
  },
  beforeLoad: async () => {
    const { useAuthStore } = await import(
      '../../features/auth/stores/auth.store'
    );
    const { getLandingPath } = await import(
      '../../shared/utils/landing-path'
    );
    const authStore = useAuthStore.getState();
    if (authStore.isLoading || !authStore.isInitialized) return;
    if (!authStore.isAuthenticated) throw redirect({ to: '/' });
    throw redirect({ to: getLandingPath(authStore.user) });
  },
  component: InsightsPage,
});

function InsightsPage() {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <h1 className="text-2xl font-semibold text-gray-700 text-center">
        Insights
      </h1>
    </div>
  );
}
